module.exports = __webpack_public_path__ + "b92822f36104292000f9e192c7bcec1b.svg";